import { Directive, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProcessingStatus } from '../../shared/processing';

@Directive({
  selector: '[appPreventClickProcessing]'
})
export class PreventClickProcessingDirective implements OnInit, OnDestroy {

  @Output()
  processClickEvent = new EventEmitter();

  subscription: Subscription;
  preventClick = false;

  constructor(private processingStatus: ProcessingStatus) { }

  ngOnInit() {
    this.subscription = this.processingStatus.getProcessingStatus().subscribe(processing => {
      this.preventClick = processing;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    if (!this.preventClick) {
      this.processClickEvent.emit(event);
    }
    this.preventClick = true;
  }
}

